import { DispositionStatusEnum } from "../../../enums/disposition.enum"

export const dispositionIsEditableHelper = (status: number): boolean => ![DispositionStatusEnum.archived, DispositionStatusEnum.locked].includes(status)